import { MDXRenderer } from 'gatsby-plugin-mdx'
import React from 'react'
import Layout from '../components/Layout'
import Img from 'gatsby-image'

export default ({ data }) => {
  const { frontmatter, body } = data.mdx

  return (
    <Layout>
      <section>
        {frontmatter?.title ? (
          <h1 className="mt-8 text-center line-wavy line-secondary text-2xl">
            {frontmatter.title}
          </h1>
        ) : null}
        {frontmatter?.tags ? (
          <div className="mt-4 text-center">
            <span className="mt-2 inline-block mr-4 py-1 px-2 border-l-4 border-secondary text-md">
              {frontmatter?.tags?.join(' / ')}
            </span>
          </div>
        ) : null}
        {frontmatter?.cover ? (
          <Img
            className="mt-8 mx-auto w-full md:w-3/4 lg:w-2/3"
            fluid={frontmatter?.cover?.childImageSharp.fluid}
          />
        ) : null}
        <MDXRenderer>{body}</MDXRenderer>
      </section>
    </Layout>
  )
}

export const pageQuery = graphql`
  query PageData($id: String) {
    mdx(id: { eq: $id }) {
      id
      body
      frontmatter {
        title
        tags
        cover {
          childImageSharp {
            fluid {
              ...GatsbyImageSharpFluid_tracedSVG
            }
          }
        }
      }
    }
  }
`
